import { Box } from "@mui/material";
import styled from "styled-components";

export const AuthLayoutStyled = styled(Box)`
  position: relative;
`;

export const AppLayoutStyled = styled(Box)<{ isHideNavbar?: boolean }>`
  padding-top: ${({ isHideNavbar }) =>
    isHideNavbar ? "0px" : "40px"} !important;
`;
